import styled from "styled-components";

export const BgHeader = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
`;
export const ContentHeader = styled.div`
  padding: 30px;
  position: sticky;
  bottom: 40px;
  right: 50%;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  z-index: 120;
  @media (max-width: 327px) {
    padding: 30px 12px;
  }
`;

export const TitleHeader = styled.h2`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  @media (max-width: 327px) {
    font-size: 15px;
  }
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: -15px;

  padding: 20px 24px;
  margin-bottom: 20px;
  @media (max-width: 327px) {
    padding: 20px 16px;
  }
`;

export const Title = styled.h1`
  color: #2a3e64;
  font-size: 20px;
  font-weight: 700;
`;

export const RadioWrraper = styled.div``;

export const Smooke = styled.div`
  margin: 3rem 0px;
`;

////////////////////

export const Pagination = styled.div``;
export const PaginationUl = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  margin: 0 auto;
  padding: 0px;
`;
export const PaginationItem = styled.li``;

export const BtnPrev = styled.button`
  padding: 10px;
  border-radius: 10px;
  background: #eaf9f8;
  color: #4495b2;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  width: 97px;
  height: 46px;
`;
export const Svg = styled.span`
  margin-top: 6px;
`;

export const BtnNext = styled.button`
  padding: 10px;
  border-radius: 10px;
  background: var(
    --linear,
    linear-gradient(164deg, #5ed2d2 0%, #5ed2b7 58.45%)
  );
  box-shadow: 0px 4px 10px 0px rgba(95, 211, 183, 0.4);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  width: 97px;
  height: 46px;
`;

export const Step = styled.p`
  border-radius: 50%;
  background: #eaedf1;
  height: 7px;
  padding: 0px 3px;
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`;
